import axios from "axios";

/**
 * @returns {Promise<axios.AxiosResponse<FedRampProduct[]>>}
 */
export function getProducts() {
  return axios.get("/sewp5public/fedramp/products");
}

/**
 * @param {number} agencyListSeq
 * @returns {Promise<axios.AxiosResponse<FedRampAgencySubAgencyModel[]>>}
 */
export function getAgencySubagencyData(agencyListSeq) {
  return axios.get(`/sewp5public/fedramp/agency-subagency-view/${agencyListSeq}`);
}

/**
 * @param {number} productSeq
 * @returns {Promise<axios.AxiosResponse<FedRampProductViewModel>>}
 */
export function getProviderDataByProduct(productSeq) {
  return axios.get(`/sewp5public/fedramp/product-view/${productSeq}`);
}

/**
 * @param {number} providerSeq
 * @param {number} productSeq
 * @returns {Promise<axios.AxiosResponse<FedRampProviderViewModel>>}
 */
export function getProviderDataByProviderAndProduct(providerSeq, productSeq) {
  return axios.get(`/sewp5public/fedramp/provider-view/${providerSeq}/${productSeq}`);
}

/**
 * @param {number} providerSeq
 * @param {number} productSeq
 * @returns {Promise<axios.AxiosResponse<FedRampContractHolder[]>>}
 */
export function getContractHolderData(productSeq, providerSeq) {
  return axios.get(`/sewp5public/fedramp/contract-holder-view/${productSeq}/${providerSeq}`);
}